// ============================================================
// Braval - New Auction Page
// ============================================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../api';
import { Header } from '../App';
import AuctionForm from './AuctionForm';

export default function NewAuctionPage() {
    const navigate = useNavigate();
    const [initialValues] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);

    const handleSave = async (formData) => {
        setIsSaving(true);
        setSaveError(null);
        try {
            const res = await apiFetch('/api/auctions', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (!res.ok) {
                const err = await res.json();
                setSaveError(err.error || 'Failed to create auction.');
                return;
            }
            const { project_id } = await res.json();
            navigate(`/auctions/${project_id}/edit`);
        } catch (err) {
            setSaveError('Could not reach the API.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="app-layout">
            <Header />
            <main className="lot-form-page">
                <AuctionForm
                    pageTitle="New Auction"
                    initialValues={initialValues}
                    onSave={handleSave}
                    isSaving={isSaving}
                    saveError={saveError}
                />
            </main>
        </div>
    );
}
